module.exports = __webpack_public_path__ + "static/Gotham-UltraItalic-41de9e777ece21ee61cde82bd2dae5b8.ttf";